module.exports = __webpack_public_path__ + "img/card-offer-courgette.41df7468.png";